
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateTenantProjectLinkDtoFormGroup() {
return new FormGroup({
    active: new FormControl<boolean | undefined>(undefined),
    sharedNotes: new FormControl<string | undefined>(''),
    externalCustomerName: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
})
;
}
      